import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import Reveal from '../ui/Reveal'
import { REVEAL_CARD_STAGGER, REVEAL_STAGGER } from '../../lib/revealMotion'

const publicUrl = process.env.PUBLIC_URL || ''

const PARTNER_ITEMS = [
  {
    id: 'bitdefender-bronze',
    image: `${publicUrl}/img/partners/bitdefender-bronze-partner.png`,
    labelKey: 'bitdefenderBronze',
  },
  {
    id: 'bitdefender-certified',
    image: `${publicUrl}/img/partners/bitdefender-certified-partner.png`,
    labelKey: 'bitdefenderCertified',
  },
  {
    id: 'bitdefender-logo',
    image: `${publicUrl}/img/partners/bitdefender-logo.png`,
    labelKey: 'bitdefender',
  },
]

export default function PartnersSection() {
  const { t } = useLanguage()

  return (
    <section className="border-t border-slate-200/80 bg-transparent">
      <div className="container-max px-4 py-12 sm:px-6 sm:py-20 lg:px-8 lg:py-24">
        <div className="mx-auto mb-8 max-w-2xl text-center sm:mb-12 lg:mb-14">
          <Reveal>
            <p className="section-label">· {t('partnersHome.eyebrow')}</p>
          </Reveal>
          <Reveal delay={REVEAL_STAGGER}>
            <h2 className="mt-4 font-heading text-2xl font-bold text-brand-navy md:text-3xl">
              {t('partnersHome.titlePrefix')}
              <span className="text-brand-green">{t('partnersHome.titleHighlight')}</span>
            </h2>
          </Reveal>
          <Reveal delay={REVEAL_STAGGER * 2}>
            <p className="mt-4 text-base leading-relaxed text-slate-600">
              {t('partnersHome.intro')}
            </p>
          </Reveal>
        </div>

        <div className="mx-auto flex max-w-2xl flex-wrap items-center justify-center gap-4 sm:max-w-3xl sm:gap-6 lg:max-w-4xl lg:gap-8">
          {PARTNER_ITEMS.map((partner, index) => (
            <Reveal key={partner.id} delay={REVEAL_STAGGER * 3 + index * REVEAL_CARD_STAGGER} className="flex items-center justify-center">
              <img
                src={partner.image}
                alt={t(`partnersHome.${partner.labelKey}`)}
                className="max-h-[18px] w-auto object-contain sm:max-h-[26px] lg:max-h-[32px]"
                loading="lazy"
                decoding="async"
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
